//** Component  */
import React from "react";
import ManageLinkBuilderList from "./ManageLinkBuilder";
import { securityKey } from "../../navigation/SecurityKey";
import CustomTab from "../../components/common/RenderTab/CustomTab";
import { hasFunctionalPermission } from "../../utils/AuthorizeNavigation/authorizeNavigation";

function LinkBuilderList() {

  const hasOpenTabPermission = hasFunctionalPermission(securityKey.LINKBUILDEROPENTAB);
  const hasArchiveTabPermission = hasFunctionalPermission(securityKey.LINKBUILDERARCHIVETAB);

  const data = [
    {
      id: "1",
      tabTitle: "Open",
      tabContent: <ManageLinkBuilderList openStatus={1} />,
      isVisible: hasOpenTabPermission?.hasAccess,
    },
    {
      id: "2",
      tabTitle: "Archive",
      tabContent: <ManageLinkBuilderList openStatus={2} />,
      isVisible: hasArchiveTabPermission?.hasAccess,
    },
  ];

  return (
    <CustomTab data={data} />
  );
}

export default LinkBuilderList;
